import { useState } from 'react';

import { ViewLayout } from '../components/ViewLayout';
import { useUrlPageState, useUrlSortState, useUrlFilterState } from '../common/filtering/filter';
import { DeviceTable } from '../components/DeviceTable';

function Content() {
  const [now, setNow] = useState(new Date());
  const queryProps = useUrlFilterState();
  const pageProps = useUrlPageState();
  const sortProps = useUrlSortState('device_id', 'asc');

  return <DeviceTable {...queryProps} {...pageProps} {...sortProps} now={now} setNow={setNow} />;
}

export default function DevicesPage() {
  return (
    <ViewLayout breadcrumbs={[{ text: 'Devices', href: '' }]} contentType="table">
      <Content />
    </ViewLayout>
  );
}
